import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import IndexPage from '@/page/IndexPage.vue';
import PortfolioPage from '@/page/PortfolioPage.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: IndexPage
  },
  {
    path: '/portfolio/:id',
    name: 'portfolio',
    component: PortfolioPage
  }
];

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition || to.path === from.path) {
      return savedPosition
    } else if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes,
});

export default router;